var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQqEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25.75H.75A.75.75 0 000 1.5v15c0 .415.335.75.75.75h19.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75zm-.938 2.597v12.216H1.688V3.347l-.646-.504.92-1.184 1.004.78h15.073l1.003-.78.92 1.184-.648.504zm-1.274-.91L10.5 8.297l-7.537-5.86-1.004-.78-.92 1.184.646.504L9.691 9.57a1.312 1.312 0 001.61 0l8.011-6.223.647-.504-.92-1.184-1.002.778z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/qq_email.4236e8d954abc36a5755477222aeb91c.svg";
export { SvgQqEmail as ReactComponent };